// removed by extract-text-webpack-plugin
module.exports = {"Container":"Politika__Container___dwO2W"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Politika/Politika.scss
// module id = 1498
// module chunks = 0